<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <MapList v-bind:maps="maps" @onMapClick="onMapClick" />
                    <Button @click="$refs.uploader.click()">Add Map</Button>
                    <input ref="uploader" style="display: none;" type="file" @change="addMap" accept="image/*" />
                </div>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
import { mapActions, mapState } from 'vuex';

import MapList from './MapList.vue';

export default {
    components: {
        MapList: MapList,
    },
    data: function() {
        return {
            isOpen: false,
        };
    },
    computed: {
        ...mapState('live', {
            director: 'director',
        }),
        ...mapState('library', {
            maps: 'maps',
        }),
    },
    created: function() {
        this.getMaps();
    },
    methods: {
        ...mapActions('library', {
            addMap: 'addMap',
            getMaps: 'getMaps',
        }),
        onMapClick: function({ map }) {
            this.$emit('onMapChosen', { map });
        },
    },
};
</script>
